// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Send Email - extends Notification styles */
.send-email-stats {
  grid-template-columns: 1fr;
  max-width: 320px;
}

.send-email-to-wrap {
  position: relative;
}

.send-email-suggestions {
  list-style: none;
  padding: 0;
  margin: 0;
}

.send-email-suggest-header {
  padding: 0.6rem 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted, #64748b);
  background: #f8fafc;
  border-bottom: 1px solid #f1f5f9;
}

.send-email-suggest-custom {
  padding: 0.75rem 1rem;
  font-size: 0.85rem;
  color: var(--text-muted, #64748b);
  background: #f8fafc;
  border-top: 1px solid #f1f5f9;
}

.send-email-suggest-empty {
  padding: 1rem;
  font-size: 0.9rem;
  color: var(--text-muted, #64748b);
  text-align: center;
}

.send-email-suggest-error {
  color: #b42318;
  font-weight: 600;
}

.send-email-suggest-active {
  background: rgba(15, 118, 110, 0.08) !important;
}

.send-email-error {
  display: block;
  margin-top: 0.35rem;
  font-size: 0.8rem;
  color: #dc2626;
}

.send-email-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.send-email-btn-clear {
  padding: 0.75rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  color: var(--text, #475569);
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s;
}

.send-email-btn-clear:hover {
  background: #e2e8f0;
}

.send-email-attachments-input {
  display: block;
  width: 100%;
  max-width: 100%;
  font-size: 0.9rem;
}

.send-email-attachments-hint {
  margin: 0.35rem 0 0;
  font-size: 0.8rem;
  color: var(--text-muted, #64748b);
}

.send-email-attachments-hint code {
  font-size: 0.75rem;
  background: #f1f5f9;
  padding: 0.1rem 0.35rem;
  border-radius: 4px;
}

.send-email-attachments-list {
  list-style: none;
  margin: 0.65rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.send-email-attachments-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0.65rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.85rem;
}

.send-email-attachments-name {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #0f172a;
}

.send-email-attachments-size {
  flex-shrink: 0;
  color: #64748b;
  font-size: 0.8rem;
}

.send-email-attachments-remove {
  flex-shrink: 0;
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: #fee2e2;
  color: #b91c1c;
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer;
}

.send-email-attachments-remove:hover {
  background: #fecaca;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Communication/SendEmailPage.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;EACjC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Send Email - extends Notification styles */\n.send-email-stats {\n  grid-template-columns: 1fr;\n  max-width: 320px;\n}\n\n.send-email-to-wrap {\n  position: relative;\n}\n\n.send-email-suggestions {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.send-email-suggest-header {\n  padding: 0.6rem 1rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-muted, #64748b);\n  background: #f8fafc;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.send-email-suggest-custom {\n  padding: 0.75rem 1rem;\n  font-size: 0.85rem;\n  color: var(--text-muted, #64748b);\n  background: #f8fafc;\n  border-top: 1px solid #f1f5f9;\n}\n\n.send-email-suggest-empty {\n  padding: 1rem;\n  font-size: 0.9rem;\n  color: var(--text-muted, #64748b);\n  text-align: center;\n}\n\n.send-email-suggest-error {\n  color: #b42318;\n  font-weight: 600;\n}\n\n.send-email-suggest-active {\n  background: rgba(15, 118, 110, 0.08) !important;\n}\n\n.send-email-error {\n  display: block;\n  margin-top: 0.35rem;\n  font-size: 0.8rem;\n  color: #dc2626;\n}\n\n.send-email-actions {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.send-email-btn-clear {\n  padding: 0.75rem 1.25rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--text, #475569);\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.send-email-btn-clear:hover {\n  background: #e2e8f0;\n}\n\n.send-email-attachments-input {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  font-size: 0.9rem;\n}\n\n.send-email-attachments-hint {\n  margin: 0.35rem 0 0;\n  font-size: 0.8rem;\n  color: var(--text-muted, #64748b);\n}\n\n.send-email-attachments-hint code {\n  font-size: 0.75rem;\n  background: #f1f5f9;\n  padding: 0.1rem 0.35rem;\n  border-radius: 4px;\n}\n\n.send-email-attachments-list {\n  list-style: none;\n  margin: 0.65rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.send-email-attachments-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.45rem 0.65rem;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.85rem;\n}\n\n.send-email-attachments-name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #0f172a;\n}\n\n.send-email-attachments-size {\n  flex-shrink: 0;\n  color: #64748b;\n  font-size: 0.8rem;\n}\n\n.send-email-attachments-remove {\n  flex-shrink: 0;\n  width: 1.75rem;\n  height: 1.75rem;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: #fee2e2;\n  color: #b91c1c;\n  font-size: 1.1rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.send-email-attachments-remove:hover {\n  background: #fecaca;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
